<template>
  <div class="video-wrapper" :class="height > width ? 'vertical' : ''">
    <div class="video">
      <FileLimitDesc v-if="withDesc" v-bind="videoInfo">
        <!--  <template slot="btn">
          <el-button type="primary" @click="$emit('upload', MATERIAL_TYPE.VIDEO)">选择视频</el-button>
        </template> -->

        <p>视频码率&gt;=512KB</p>
        <p>横版分辨率&gt;=1280&times;720，大小&lt;=100M</p>
        <p>竖版分辨率&gt;=720&times;1280，大小&lt;=100M</p>
      </FileLimitDesc>

      <el-tag class="badge">视频{{ index + 1 }}</el-tag>

      <img v-if="$attrs.preview_url" loading="lazy" :src="$attrs.preview_url" alt="" />
      <div class="asset-name">
        <p v-if="width">
          <el-tag type="info">{{ width }}&times;{{ height }}</el-tag>
        </p>
        <p v-if="size">
          <el-tag type="info">{{ (size / 1024 / 1024).toFixed(2) }}M</el-tag>
        </p>
        <p>
          <el-tag type="info">{{ $attrs.name }}</el-tag>
        </p>
      </div>
    </div>

    <div class="poster" v-if="posterInfo">
      <FileLimitDesc v-if="withDesc" v-bind="posterInfo">
        <template v-if="coverReplaceable" slot="btn">
          <el-button type="primary" @click="$emit('upload', MATERIAL_TYPE.POSTER)">选择封面</el-button>
        </template>

        <p>需和视频同比例，大小不超过500KB</p>
        <p>横版16:9，最低尺寸1280*720</p>
        <p>竖版9:16，最低尺寸720*1280</p>
      </FileLimitDesc>
      <img loading="lazy" :src="$attrs.cover_url" alt="" />
      <i v-if="withDesc" class="remove el-icon-error" @click="$emit('remove')"></i>
      <div class="asset-name">
        <p v-if="cover_width">
          <el-tag type="info">{{ cover_width }}&times;{{ cover_height }}</el-tag>
        </p>
        <p v-if="$attrs.cover_size">
          <el-tag type="info">{{ ($attrs.cover_size / 1024 / 1024).toFixed(2) }}M</el-tag>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import FileLimitDesc from './material-desc.vue'
export default {
  components: { FileLimitDesc },
  props: {
    size: { type: Number },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    cover_height: {
      type: Number
    },
    cover_width: {
      type: Number
    },
    index: {
      type: Number
    },
    // 是否显示描述和关闭按钮，默认显示
    withDesc: {
      type: Boolean,
      default: true
    },
    coverReplaceable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return { MATERIAL_TYPE_ID, MATERIAL_TYPE }
  },
  computed: {
    posterInfo() {
      return {
        description: '视频封面',
        width: this.cover_width,
        height: this.cover_height
      }
    },
    videoInfo() {
      return {
        description: '视频',
        width: this.width,
        height: this.height
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
